import fetchIntercept from 'fetch-intercept';
import {signOut} from '../actions/authentication';

import {jsonToQueryString} from './utils';

const endpoints = {
  /**
   * Add a match for a LFP Game
   * @Method: POST @Params: Number day YYYY-MM-DD start, end
   * @return: Response
   */
  addLfpGameMatch: () => `/game-lfp/addGame`,
  /**
   * Create a new LFP Game
   * @Method: POST @Params: Number day YYYY-MM-DD start, end
   * @return: Response
   */
  createLfpGame: () => `/game-lfp/addDay`,
  /**
   * Retrieve a league by its password
   * @Method: GET
   * @return: Object League
   */
  /**
   * Fetch LFPGame
   * @Method: GET @Params: none
   * @return: Object
   */
  fetchLfpGame: ({day}) => `/game-lfp/${day}`,
  /**
   * Fetch LFPGame Winners
   * @Method: GET @Params: day
   * @return: Object winners
   */
  fetchLfpGameWinners: ({day}) => `/game-lfp/tirage/${day}`,
  /**
   * Fetch player with ID
   * @Method: GET @Params: String playerId
   * @return: Player Object
   */
  fetchPlayer: ({playerId}) => `/player/${playerId}`,
  /**
   * Fetch all players
   * @Method: GET @Params: Int championship
   * @return: Players Array
   */
  fetchPlayers: ({championship}) => `/players/${championship}`,
  /**
   * Fetch all players for quotation management
   * @Method: GET @Params: Int championship
   * @return: Players Array
   */
  fetchPlayersQuotations: ({championship}) => `/quotation/${championship}`,
  /**
   * Fetch profile of current user
   * @Method: GET @Params: none
   * @return: Object
   */
  fetchProfile: () => `/user`,
  /**
   * Fetch registrations statistics
   * @Method: POST @Params: Date start, end
   * @return: Object
   */
  fetchStatsRegistrations: payload =>
    `/stats/users-creations${jsonToQueryString(payload)}`,
  /**
   * Retrieve user info by email
   * @Method: POST @Body: String email
   * @return: Object
   */
  fetchUser: identifier => `/user/${identifier}`,
  /**
   * Send request forgot password
   * @Method: POST @Body: String email
   * @return: Object
   */
  requestPassword: () => `/user/force-password`,
  /**
   * Sign in user
   * @Method: POST @Body: String email, String password, Enum language ['fr-FR', 'en-GB', 'es-ES']
   * @return: Object { "token" , "userId" }
   */
  signIn: () => `/user/signIn`,
  /**
   * Update data for gameweek preview
   * @Method: POST @body: champid, id, type, value
   * @return: Response
   */
  postTds: ({champid}) => `/tds/${champid}`,
  /**
   * Update OPTA
   * @Method: GET @params: champid
   * @return: Response
   */
  getOptaState: champid => `/opta_update/${champid}`,
  /**
   * Get OPTA picture
   * @Method: GET @params: champid
   * @return: Response
   */
  getOptaPicture: champid => `/generateImage/${champid}`,
  /**
   * Get Top Players
   * @Method: GET @params: champid
   * @return: Response
   */
  getTopPlayers: champid => `/topflop/${champid}/top`,
  /**
   * Get Flop Players
   * @Method: GET @params: champid
   * @return: Response
   */
  getFlopPlayers: champid => `/topflop/${champid}/flop`,
  /**
   * Fetch MPP League
   * @Method: GET @params: password
   * @return: League
   */
  fetchMPPLeague: ({contestId}) => `/contest/${contestId}`,
  updateMPPLeague: challengeId => `/challenge/${challengeId}`,
  /**
   * Fetch MPP League Stats
   * @Method: GET
   * @return: Leagues
   */
  fetchMPPActiveLeagues: () => '/stats/leagues-by-size',
  /**
   * Fetch MPP User Stats
   * @Method: POST
   * @return: { range, all }
   */
  fetchStatsMppUsers: ({end, start}) =>
    `/stats/users/creations?startDate=${start}&endDate=${end}`,
  getMptClubs: () => '/mpt/clubs',
  editMptClub: ({clubId}) => `/mpt/clubs/${clubId}`,
  postMptClub: () => '/mpt/club',
  getMptWeeks: () => '/mpt/weeks',
  editMptWeek: weekId => `/mpt/weeks/${weekId}`,
  editMptCard: ({weekId, cardId}) => `/mpt/${weekId}/cards/${cardId}`,
  editMptDestination: ({cardId, dest}) => `/mpt/${cardId}/destination/${dest}`,
  postMptDestination: ({cardId}) => `/mpt/${cardId}/destination`,
  postMptDestinationD0: ({cardId}) => `/mpt/${cardId}/destination/stay`,
  postMptDestinationD6: ({cardId}) => `/mpt/${cardId}/destination/other`,
  postMptWeek: () => '/mpt/weeks',
  postMptCard: weekId => `/mpt/${weekId}/cards`,
  publishMPT: () => '/mpt/publish',
  validateTransfert: ({weekId, cardId}) =>
    `/mpt/${weekId}/cards/${cardId}/validate`,
  startCalculation: () => '/mpt/validate',
  checkRunning: () => '/mpt/running',
  createAlertInApp: () => '/alert',
  validateAlertInApp: alertId => `/alert/validate/${alertId}`,
  getAllAlerts: () => '/alerts',
  deleteAlert: alertId => `/alert/${alertId}`,
  getAlert: alertId => `/alert/${alertId}`,
  updateAlert: alertId => `/alert/${alertId}`,
  fetchStatsMptUsers: () => '/mpt/users',
  fetchStatsMptCards: () => '/mpt/users/cards',
  fetchSuggestedQuotations: ({championship}) =>
    `/players/${championship}/suggested-quotations`,
  updateSuggestedQuotation: ({id}) => `/suggested-quotations/${id}`,
  applySuggestedQuotations: ({id}) => `/suggested-quotations/apply/${id}`,

  fetchStatsSales: payload => `/stats/purchases${jsonToQueryString(payload)}`,
  fetchStatsPlatforms: payload =>
    `/stats/users-connections-platforms${jsonToQueryString(payload)}`,
  fetchStatsLeagues: payload =>
    `/stats/leagues-creations${jsonToQueryString(payload)}`,
  fetchStatsLeaguesByStatus: payload =>
    `/stats/leagues-statuses${jsonToQueryString(payload)}`,
  fetchStatsLeaguesRestart: payload =>
    `/stats/leagues-restarts${jsonToQueryString(payload)}`,
  fetchStatsLeaguesReactivated: payload =>
    `/stats/league-reactivated-by-players-count${jsonToQueryString(payload)}`,
  fetchStatsNewActiveUsers: payload =>
    `/stats/new-users-active-in-league${jsonToQueryString(payload)}`,
  fetchStatsActiveUsers: payload =>
    `/stats/active-users${jsonToQueryString(payload)}`,
  fetchStatsNewUsersFunnel: payload =>
    `/stats/new-users-funnel${jsonToQueryString(payload)}`,
  fetchSeasonActiveUsers: () => '/stats/users-current-activity',
  fetchStatsUserConnections: () => '/stats/users-connections',

  //Tournaments
  fetchStatsTournaments: payload =>
    `/stats/tournaments-creations${jsonToQueryString(payload)}`,
  fetchStatsTournamentsByStatus: payload =>
    `/stats/tournaments-statuses${jsonToQueryString(payload)}`,
  fetchStatsTournamentsRounds: payload =>
    `/stats/tournaments-rounds${jsonToQueryString(payload)}`,
  fetchStatsTournamentsAverageSizes: payload =>
    `/stats/tournaments-average-sizes${jsonToQueryString(payload)}`,
  fetchStatsTournamentsByUsers: payload =>
    `/stats/tournaments-by-users${jsonToQueryString(payload)}`,
  fetchStatsTournamentsActiveUsers: () => `/stats/tournaments-active-users`,

  hideUserLeague: ({userId, leagueId}) => `/user/${userId}/hide/${leagueId}`,
  showUserLeague: ({userId, leagueId}) => `/user/${userId}/show/${leagueId}`,

  fetchUserPurchases: ({userId}) => `/user/${userId}/purchases`,
  fetchLeaguePurchases: ({leagueId}) => `/league/${leagueId}/purchases`,
  restartDraft: ({draftId}) => `/draft/${draftId}/reset`,
  updateLeague: leagueId => `/league/${leagueId}`,

  getAlertStats: () => '/alert/stats',

  updateUser: id => `/user/${id}`,

  //MPGTB
  getUsersStatsMPGTB: payload =>
    `/stats/mpgtb/users-creation${jsonToQueryString(payload)}`,
  getSupportersStatsMPGTB: payload =>
    `/stats/mpgtb/supporters${jsonToQueryString(payload)}`,
  getWallStatsMPGTB: payload =>
    `/stats/mpgtb/wall${jsonToQueryString(payload)}`,
  getCommentsMPGTB: () => '/mpgtb/wall/moderation',
  deleteCommentMPGTB: idComment => `/mpgtb/wall/moderation/${idComment}`,
  getRankingMPGTB: () => '/mpgtb/ranking',

  // Data com
  fetchStatsPlayersValue: payload => `/stats/bids${jsonToQueryString(payload)}`,
  fetchStatsPlayersNumberInTeam: payload =>
    `/stats/teams-sizes${jsonToQueryString(payload)}`,
  fetchStatsPlayersGoals: payload =>
    `/division-matches-players-stats/${payload.championship}?season=${payload.season}`,
  fetchStatsMatchesLineUp: payload =>
    `/stats/compositions${jsonToQueryString(payload)}`,
  fetchStatsMatchesGoals: payload =>
    `/division-matches-stats/${payload.season}`,
  fetchStatsBadges: payload => `/division-matches-stats/${payload.season}`,
  fetchMatchDays: payload =>
    `/championship-calendars/past-game-weeks${jsonToQueryString(payload)}`,

  // Godfather
  fetchGodfatherLevels: () => '/stats/godfather',
  fetchGodfatherRegistrations: payload =>
    `/stats/godfather/registrations${jsonToQueryString(payload)}`,

  // Stats Messaging
  fetchStatsMailPush: payload =>
    `/stats/notifications${jsonToQueryString(payload)}`,
  fetchMailPushByUser: ({userId}) => `/user/${userId}/notifications`,
  fetchAlertsByUser: ({userId}) => `/user/${userId}/alerts`,
  fetchSequences: appName =>
    `/messaging/sequences${appName ? `?appName=${appName}` : ''}`,

  //Jerseys
  getJerseys: () => `/jerseys-temp`,
  createJersey: () => `/jersey-temp`,
  getCollections: ({language}) =>
    `/jersey-collections-temp?language=${language}`,
  editMasterLeague: masterLeagueId => `/master-league/${masterLeagueId}`,
  fetchStatsMasterLeagues: payload =>
    `/stats/master-league-creations${jsonToQueryString(payload)}`,
  fetchStatsMasterLeaguesByStatus: payload =>
    `/stats/master-league-by-status${jsonToQueryString(payload)}`,
  fetchStatsMasterLeaguesRestart: payload =>
    `/stats/master-league-restart${jsonToQueryString(payload)}`,
  //
  createNotification: () => `/in-app-notif`,
  getAllNotifications: () => `/in-app-notifs`,
  getNotificationsClicks: () => `/in-app-notif/stats`,
  deleteNotification: notificationId => `/in-app-notif/${notificationId}`,
  updateNotification: notificationId => `/in-app-notif/${notificationId}`,
  calculateTarget: () => `/target/count`,
  getSingleNotification: notificationId => `/in-app-notif/${notificationId}`,
  validateNotification: notificationId =>
    `/in-app-notif/validate/${notificationId}`,
  sendInAppNotifUsersTest: notificationId =>
    `/in-app-notif/${notificationId}/test`,
  sendAlertUsersTest: alertId => `/alert/${alertId}/test`,
  jobs: ({category}) => `/jobs?category=${category}`,
  // Daily report
  getDailyReportAcquisition: refresh =>
    `/daily-report/acquisition?refresh=${refresh}`,
  getDailyReportLoyalty: refresh => `/daily-report/loyalty?refresh=${refresh}`,
  getDailyReportFreemium: refresh =>
    `/daily-report/freemium?refresh=${refresh}`,
  getUsersRetention: () => `/stats/users-retention`,

  getUserVersions: userId => `/user/${userId}/versions`,
  getUsersByChampionship: ({championship, season}) =>
    `/stats/users-matches?championshipId=${championship}&season=${season}`,

  // NEW VERSION
  googleSignIn: () => `/google/auth`,
  setAvatarToDefault: userId => `/user/${userId}/reset-avatar`,
  hideLeague: userId => `/user/${userId}/hidden-league`,
  forceUserPassword: userId => `/user/${userId}/reset-password`,
  removeUser: userId => `/user/${userId}/delete-user`,
  creditTimedOption: userId => `/user/${userId}/credit-timed-option`,
  editMoney: userId => `/user/${userId}/money`,
  getUserPurchases: userId => `/user/${userId}/purchases`,
  editUserOptins: userId => `/user/${userId}/optins`,

  fetchTournament: tournamentId => `/tournament/${tournamentId}`,
  updateTournamentName: tournamentId => `/tournament/${tournamentId}/name`,
  updateTournamentIsPublic: tournamentId =>
    `/tournament/${tournamentId}/is-public`,
  getTournamentUsers: tournamentId => `/tournament/${tournamentId}/users`,

  fetchLeague: leagueId => `/league/${leagueId}`,
  setLeagueImageToDefault: leagueId => `/league/${leagueId}/reset-image`,
  changeLeagueRating: leagueId => `/league/${leagueId}/rating`,
  changeMercatoStartDate: leagueId => `/league/${leagueId}/mercato-start-date`,
  changeMercatoInAuto: leagueId => `/league/${leagueId}/set-mercato-auto-close`,
  getDivisionInfos: divisionId => `/division/${divisionId}`,
  setDivisionMode: divisionId => `/division/${divisionId}/set-expert-mode`,
  getLeagueUsers: leagueId => `/league/${leagueId}/users`,
  getDivisionPurchases: divisionId => `/division/${divisionId}/purchases`,
  fetchRankingByLeague: ({divisionId}) =>
    `/division/${divisionId}/ranking/standings`,
  getDivisionUsers: divisionId => `/division/${divisionId}/users`,
  fetchCalendarByDivisionByGameWeekNumber: ({divisionId, gameWeekNumber}) =>
    `/division/${divisionId}/calendar/game-week/${gameWeekNumber}/matches`,
  fetchCalendarByDivision: divisionId => `/division/${divisionId}/calendar`,
  fetchPlayerPool: ({championship}) =>
    `/championship-players-pool/${championship}/players`,
  fetchTds: ({championship}) =>
    `/championship-players-statuses/${championship}`,
  getNextGameWeekByChampiomshipId: championshipId =>
    `/championship-calendar/${championshipId}/next-game-week`,
  getChampionshipCalendarByChampionshipId: championshipId =>
    `/championship-calendar/${championshipId}`,
  fetchMPPStatsActiveUsers: payload =>
    `/stats/active-users${jsonToQueryString(payload)}`,
  getChampionshipClubs: () => `/championship-clubs`,
  changeChampionshipPlayerStatus: ({championshipId, championshipPlayerId}) =>
    `/championship-players-statuses/${championshipId}/championship-player/${championshipPlayerId}`,
  updateTdsByGameWeek: ({championshipId, gameWeekNumber}) =>
    `/championship-players-statuses/${championshipId}/game-week/${gameWeekNumber}/updated`,
  fetchFullPlayers: ({championship}) =>
    `/championship-players/${championship}/full`,
  updatePlayer: ({id}) => `/championship-player/${id}`,
  importOpta: ({championship}) =>
    `/championship-players/${championship}/import`,
  inAndOut: ({championship}) =>
    `/championship-players/${championship}/in-and-out`,
  updateListProd: ({championship}) =>
    `/championship-players-pool/${championship}/players`,
  updateDataByChampionshipId: ({championship}) =>
    `/championship-players-stats/${championship}/update`,
  updateCollectionInfos: ({collectionId, language}) =>
    `/jersey-collection-temp/${collectionId}?language=${language}`,
  orderCollections: () => `/jersey-collections-temp/order`,
  getJerseyShop: ({language, useTemp, previewDate}) => {
    if (previewDate)
      return `/jersey-collections-temp/shop/preview?language=${language}&useTemp=${useTemp}&previewDate=${previewDate}`;
    return `/jersey-collections-temp/shop/preview?language=${language}&useTemp=${useTemp}`;
  },
  updateJerseyInfos: jerseyId => `/jersey-temp/${jerseyId}`,
  createCollection: () => `/jersey-collection-temp`,
  uploadPicture: type => `/image/upload/${type}/temp`,
  updateJerseyShop: language =>
    `/jersey-collections-temp/shop/apply?language=${language}`,
  fetchMatches: ({championship, day}) =>
    `/championship-matches/${championship}/game-week/${day}/details`,
  fetchMatch: ({matchId}) => `/championship-match/${matchId}`,
  updatePlayerMatchMark: ({playerId, mark, matchId}) =>
    `/championship-match/${matchId}/championship-player/${playerId}/rating`,
  createBlogPost: () => '/blog-post',
  getBlogPostById: blogPostId => `/blog-post/${blogPostId}`,
  updateBlogPost: blogPostId => `/blog-post/${blogPostId}`,
  postImageUpload: () => '/image/upload',
  getAllBlogPosts: () => '/blog-posts',
  deleteBlogPostById: blogPostId => `/blog-post/${blogPostId}`,
  calculateBlogPostTargeting: () => '/blog-post/calculate-target-size',
  publishBlogPost: blogPostId => `/blog-post/${blogPostId}/publish`,
  getBlogPostsStats: () => '/blog-posts/stats',
  getNewsFeed: () => '/news-posts',
  getNewsFeedStats: () => '/news-posts/stats',
  deleteNewsPostById: newsPostId => `/news-post/${newsPostId}`,
  createNewsPost: () => '/news-post',
  getNewsPostById: newsPostId => `/news-post/${newsPostId}`,
  updateNewsPost: newsPostId => `/news-post/${newsPostId}`,
  publishNewsPost: newsPostId => `/news-post/${newsPostId}/publish`,
  getTwitterHtml: () => '/tools/twitter',
  fetchStatsLeaguesModes: season => `/stats/leagues-modes?endDate=${season}`,

  getMPPScorers: championshipId => `/competition/${championshipId}/players`,
  patchMPPScorer: ({championshipId, playerId, cantWinAnymore}) =>
    `/competition/${championshipId}/player/${playerId}/cantWinAnymore?cantWinAnymore=${cantWinAnymore}`,
  getMPPSelections: championshipId =>
    `/competition/${championshipId}/selections`,
  patchMPPSelection: ({championshipId, clubId, outOfCompetition}) =>
    `/competition/${championshipId}/club/${clubId}/outOfCompetition?outOfCompetition=${outOfCompetition}`,
  getMPPMatches: () => '/matches',
  patchMPPQuotation: matchId => `/match/${matchId}`,
  updateMatchsQuotations: () => `/competition/update-quotations`,
  fetchMPPUsersConnections: () => '/users-stats/users-connections',
  getMPPChallengesStats: () => '/stats/users/challenge/supervised-played',

  // Question bonus
  createBonusQuestion: () => `/bonus-question`,
  bonusQuestion: bonusQuestionId => `/bonus-question/${bonusQuestionId}`,
  cancelBonusQuestion: bonusQuestionId =>
    `/bonus-question/${bonusQuestionId}/cancel`,
  resolveBonusQuestion: bonusQuestionId =>
    `/bonus-question/${bonusQuestionId}/resolve`,
  getBonusQuestions: ({championshipId, season, status}) =>
    `/bonus-question?championshipId=${championshipId}${
      season ? `&season=${season}` : ''
    }`,
  getBonusQuestionGameWeeks: ({championshipId, season}) =>
    `/bonus-question/${championshipId}/game-weeks${
      season ? `?season=${season}` : ''
    }`,
  getBonusQuestionGameWeekMatches: ({championshipId, gameWeekNumber, season}) =>
    `/bonus-question/${championshipId}/game-weeks/${gameWeekNumber}/matches${
      season ? `?season=${season}` : ''
    }`,
  getContestsStatsByStatus: ({contestType, payload}) =>
    `/stats/contests/${contestType}/summary${jsonToQueryString(payload)}`,
  getAverageContestsDuration: ({contestType, payload}) =>
    `/stats/contests/${contestType}/duration${jsonToQueryString(payload)}`,
  getAverageContestsByUser: ({contestType, payload}) =>
    `/stats/contests/${contestType}/joined${jsonToQueryString(payload)}`,
  getCreatedContests: ({contestType, payload}) =>
    `/stats/contests/${contestType}/created${jsonToQueryString(payload)}`,
  getAverageContestsSize: ({contestType, payload}) =>
    `/stats/contests/${contestType}/size${jsonToQueryString(payload)}`,
  getMPPUsersByChampionship: ({championship, season}) =>
    `/users-stats/users-forecasts-by-championship?championshipId=${championship}&season=${season}`,

  getUberEatsWinners: () => '/event-uber-eats-1/winners-summary',
  getUberEatsGame: () => '/event-uber-eats-1/calendar',
  updateUberEatsGame: () => '/event-uber-eats-1/calendar',
  updateUberEatsWinners: () => '/event-uber-eats-1/winners-summary',
  getUberEatsUsersByDay: ({end, start}) =>
    `/event-uber-eats-1/stats/users-by-day?startDate=${start}&endDate=${end}`,
  getUberEatsUsersByGameWeek: () =>
    '/event-uber-eats-1/stats/users-by-game-week',
  getUberEatsUsersResults: ({gameWeekName, matchId}) =>
    `/event-uber-eats-1/${gameWeekName}/${matchId}/winners`,
  getUberEatsUsersSecondaryWinners: ({gameWeekName, matchId}) =>
    `/event-uber-eats-1/${gameWeekName}/${matchId}/secondary-winners`,
  getUberEatsConfig: () => '/event-uber-eats-1/config',

  fetchStatsMPMUsers: ({end, start}) =>
    `/stats/users-creations?startDate=${start}&endDate=${end}`,
  fetchMPMUsersByMatches: ({competitionId, competitionYear}) =>
    `/stats/users-by-matches?competitionId=${competitionId}&competitionYear=${competitionYear}`,
  fetchMPMUsersConnections: () => '/stats/users-connections',
  fetchMPMStatsPlatforms: payload =>
    `/stats/users-connections-by-platform${jsonToQueryString(payload)}`,
  fetchMPMMatchesBadges: payload =>
    `/stats/matches-badges${jsonToQueryString(payload)}`,
  getChampionships: () => '/championships',
  getActiveChampionships: () => '/championships/active',

  //MXI
  getMXIChampionshipCalendar: championshipId =>
    `/championship-calendar/${championshipId}`,
  getMXIChampionshipPlayerPool: championshipId =>
    `/championship-players-pool/${championshipId}/details`,
  updateMXIPlayer: ({championshipPlayerId}) =>
    `/championship-player/${championshipPlayerId}/quotations`,
  updateMXIGameWeek: ({championshipId, gameWeekNumber, confirm}) =>
    `/championship-calendar/${championshipId}/open-game-week/${gameWeekNumber}${
      confirm === true ? '?confirm=true' : ''
    }`,
  createMPPChallenge: () => `/challenge`,
  updateMPPChallenge: challengeId => `/challenge/mpp_challenge_${challengeId}`,

  getChangelog: () => '/changelog',
  createVersion: () => '/changelog/version',
  version: version => `/changelog/version/${version}`,
  article: ({version, uuid}) =>
    `/changelog/version/${version}/article${uuid ? `?uuid=${uuid}` : ''}`,

  updatePrize: ({championshipId, gameWeekNumber}) =>
    `/prizes-pools/championship/${championshipId}/game-week/${gameWeekNumber}`,
};

export let headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export const getEndpoint = (key, params) => {
  if (!endpoints[key]) console.error(`"${key}" is not a valid endpoint.`);
  else return process.env.API_PATH + endpoints[key](params);
};

export const getMPPEndpoint = (key, params) => {
  if (!endpoints[key]) console.error(`"${key}" is not a valid endpoint.`);
  else return process.env.MPP_API_PATH + endpoints[key](params);
};

export const getMPMEndpoint = (key, params) => {
  if (!endpoints[key]) console.error(`"${key}" is not a valid endpoint.`);
  else return process.env.MPM_API_PATH + endpoints[key](params);
};

export const getMXIEndpoint = (key, params) => {
  if (!endpoints[key]) console.error(`"${key}" is not a valid endpoint.`);
  else return process.env.MXI_API_PATH + endpoints[key](params);
};

export const getFantasyEndpoint = (key, params) => {
  if (!endpoints[key]) console.error(`"${key}" is not a valid endpoint.`);
  else return process.env.FANTASY_API_PATH + endpoints[key](params);
};

export const getHeaders = authentication => {
  if (authentication && authentication.token)
    headers['Authorization'] = authentication.token;

  return headers;
};

export const fetchInterceptor = dispatch => {
  fetchIntercept.register({
    request: function (url, config) {
      return [url, config];
    },

    requestError: function (error) {
      return Promise.reject(error);
    },

    response: async function (response) {
      if (response.status === 401) {
        const GoogleAuth = await window.gapi.auth2.getAuthInstance();
        GoogleAuth.signOut();
        return dispatch(signOut());
      }
      return response;
    },

    responseError: function (error) {
      // Handle an fetch error
      return Promise.reject(error);
    },
  });
};



// WEBPACK FOOTER //
// ./src/helpers/endpoint.js